import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Сессия живёт в httpOnly-cookie: заголовок Authorization больше не нужен.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    const url: string = error.config?.url || ''
    const onLogin = window.location.pathname === '/login'
    // /auth/me сам решает, что делать с 401, иначе страница входа зациклится
    if (status === 401 && !url.endsWith('/auth/me') && !onLogin) {
      const redirect = encodeURIComponent(window.location.pathname + window.location.search)
      window.location.href = `/login?redirect=${redirect}`
    }
    if (status === 403 && !onLogin) {
      window.location.href = '/login?pending=1'
    }
    return Promise.reject(error)
  }
)

export default api
